import React from "react";
import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

const ConfirmDialog = (props) => {
  const {
    description,
    title,
    handleClose,
    handleSuccess,
    showDialog,
    selectedInfo,
    showContent = false,
    fullWidth = false,
    hideDeleteButton,
    maxWidth,
    buttonLabel,
    children,
  } = props;
  const buttonStyles = {
    backgroundColor: "#005572",
    color: "#fff",
    "&:hover, &:focus, &:active, &:disabled": {
      backgroundColor: "#005572",
      boxShadow: "none",
    },
  };

  return (
    <>
      <Dialog
        fullWidth={fullWidth}
        open={showDialog}
        maxWidth={maxWidth || undefined}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {!showContent && (
          <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        )}
        <DialogContent>
          {showContent ? (
            <>{children}</>
          ) : (
            <DialogContentText id="alert-dialog-description">
              {description}
            </DialogContentText>
          )}
        </DialogContent>
        {!showContent && (
          <DialogActions>
            <Button variant="contained" onClick={handleClose} color="error">
              Cancel
            </Button>
            {!hideDeleteButton && (
              <Button
                variant="contained"
                onClick={() => handleSuccess(selectedInfo)}
              >
                {buttonLabel ? buttonLabel : "Confirm"}
              </Button>
            )}
          </DialogActions>
        )}
        {showContent && (
          <DialogActions>
            <Button
              variant="contained"
              onClick={() => handleClose()}
              sx={buttonStyles}
            >
              Close
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </>
  );
};

ConfirmDialog.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string,
  handleClose: PropTypes.func,
  handleSuccess: PropTypes.func,
  showDialog: PropTypes.bool,
  selectedTenantInfo: PropTypes.object,
  showContent: PropTypes.bool,
  fullWidth: PropTypes.bool,
  maxWidth: PropTypes.string,
};

export default ConfirmDialog;
